import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  input,
  signal,
  inject,
  output,
  EventEmitter
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DNComment } from '../../domain/content/content.model';
import { TemplateCt } from '../../domain/template-ct/template-ct.model';
import { CommentsService } from './comments.service';
import { CommentHistoryComponent } from './comment-history/comment-history.component';
import { SigninDirective } from '../util/directives/signin/signing-directive';
import { CommentBoxComponent } from './comment-box/comment-box.component';
import { Store } from '@ngrx/store';
import { selectCommentsByParentId } from '../../domain/content/content.selectors';

export interface CreateCommentDTO {
  commentText: string;
  // attachment template if any
  attachmentTemplate?: TemplateCt;
  // comment being replied if any
  parentComment?: DNComment;
}

@Component({
  selector: 'dottnet-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommentBoxComponent, SigninDirective, CommentHistoryComponent],
  standalone: true
})
export class CommentsComponent implements OnInit, OnDestroy {
  private store = inject(Store);


  readonly comments = input<DNComment[]>([]);


  readonly loadCommentRepliesEmitter = output<DNComment>();

  // Aggiungi un nuovo input per ricevere l'emitter dal genitore
  readonly replyBus = input<EventEmitter<DNComment>>(null);
  // Nuovo input per ricevere il submitCommentBus dal genitore
  readonly submitCommentBus = input<EventEmitter<CreateCommentDTO>>(null);

  readonly uploadTemporaryAttachmentEmitter = output<File>();
  readonly showAttachmentEmitter = output<{ idAttachment: number, templateAttachment: string }>();

  // UI vars
  commentSectionTitle: string = this.ts.instant('dottnet.title.comments');
  permissionDialogTitle: string = this.ts.instant('dottnet.permessi.commentPermission');

  // Sublist
  subList: Subscription[] = [];

  constructor(private ts: TranslateService, private commentsService: CommentsService) {

  }

  // Subscribe to commentsService subjects
  ngOnInit(): void {
    this.subList.push(
      this.commentsService
        .onUploadTemporaryAttachment()
        .subscribe((file) => this.emitUploadTemporaryAttachment(file)),
      this.commentsService
        .onShowAttachment()
        .subscribe(({ idAttachment, templateAttachment }) =>
          this.emitShowAttachment(idAttachment, templateAttachment)
        )
    );
  }

  ngOnDestroy(): void {
    this.subList.forEach((sub) => sub.unsubscribe());
  }



  emitSubmitComment(commentDTO: CreateCommentDTO) {
    if (this.submitCommentBus()) {
      this.submitCommentBus().emit(commentDTO);
    }
  }

  emitUploadTemporaryAttachment(file: File) {
    this.uploadTemporaryAttachmentEmitter.emit(file);
  }

  emitShowAttachment(idAttachment: number, templateAttachment: string) {
    this.showAttachmentEmitter.emit({ idAttachment, templateAttachment });
  }
}
